<template>
  <div>
    <div v-for="(standard,index) in value.standardList" :key="standard.itemId">
      <el-divider v-if="index>0"></el-divider>
      <div><i class="el-icon-caret-right" style="margin-right: 5px;color: #32A08C"></i>{{standard.itemName}}</div>
      <el-tag style="margin-right: 10px"
              v-for="(tag,sindex) in standard.standardList"
              :key="tag.itemId" effect="plain"
              type="success"
              @close="handleDelItem(index,sindex)"
              closable>
        {{tag.itemName}}
      </el-tag>
    </div>
  </div>
</template>

<script>
export default {
  name: 'standard-item-display',
  props: {
    value: {
      type: Object,
      default: function () {
        return {}
      }
    },
    proIndex: {
      type: Number,
      default: 0
    }
  },
  mounted () {
  },
  methods: {
    handleDelItem (index, sindex) {
      this.value.standardList[index].standardList.splice(sindex, 1)
      if (this.value.standardList[index].standardList.length === 0) {
        this.value.standardList.splice(index, 1)
      }
      this.$emit('change')
    }
  }
}
</script>

<style scoped>

</style>
